import { ApolloClient } from "@apollo/client";
import { getAppUrl, getCurrentApp, getDomainLevel } from "utilities/routes";
import { getEnvironment } from "utilities/environment";
import { flavorDomain } from "utilities/flavor";
import logoutMutation from "./logoutMutation.gql";

const env = getEnvironment();

let JWT_KEY = env + "-JWT";

export const setJwt = (jwt: string) => {
  const exp = new Date();
  exp.setFullYear(exp.getFullYear() + 10);
  document.cookie = `${JWT_KEY}=${jwt}; path=/; domain=${
    env === "development" ? "localhost" : getDomainLevel(2)
  }; expires=${exp.toUTCString()};`;
};

export const getJwt = (): string => {
  return getCookie(JWT_KEY) || "";
};

export const isLoggedIn = (): boolean => !!getJwt();

export const logout = async () => {
  window.location.href = getAppUrl("accounts", "logout");
};

export const clearJWTAndRedirect = (keepPath: boolean = false) => {
  setJwt("");
  localStorage.clear();
  redirectIfNotLoggedIn(keepPath);
};

export const goToLogin = (keepPath: boolean = true) => {
  const orgId =
    env === "development"
      ? window.location.href.split("/").slice(4, 5).join("/")
      : window.location.href.split("/").slice(3, 4).join("/");

  window.location.href = getAppUrl(
    "accounts",
    `${orgId.length > 0 ? orgId : "_"}/login`,
    keepPath
      ? {
          continueUrl: window.location.href,
        }
      : {
          continueUrl: getAppUrl(getCurrentApp() || "accounts"),
        },
  );
};

export const redirectIfNotLoggedIn = (keepPath?: boolean) => {
  if (!isLoggedIn()) {
    return goToLogin(keepPath);
  }
};

const getCookie = (name: string) => {
  const pair = document.cookie.match(new RegExp(name + "=([^;]+)"));
  return !!pair ? pair[1] : null;
};
